module.exports = __webpack_public_path__ + "img/futuristic_outer_space_view-wallpaper-1440x900.619f5bcd.jpg";